const DailyStats = () => {
  return <div></div>;
};

export { DailyStats };
